import * as React from "react";
const useIsoLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
function setFlag(element, name, on) {
  if (on) {
    if (element.getAttribute(name) !== "true") element.setAttribute(name, "true");
  } else if (element.hasAttribute(name)) {
    element.removeAttribute(name);
  }
}
function isRtl(element) {
  return typeof getComputedStyle === "function" && getComputedStyle(element).direction === "rtl";
}
function prefersReducedMotion() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function updateScrollFade(scroller) {
  const max = scroller.scrollWidth - scroller.clientWidth;
  if (max <= 1) {
    setFlag(scroller, "data-fade-left", false);
    setFlag(scroller, "data-fade-right", false);
    return;
  }
  const fromLeft = isRtl(scroller) ? scroller.scrollLeft + max : scroller.scrollLeft;
  setFlag(scroller, "data-fade-left", fromLeft > 1);
  setFlag(scroller, "data-fade-right", fromLeft < max - 1);
}
function revealInScroller(scroller, item, smooth) {
  if (!item || !scroller.contains(item)) return;
  if (scroller.scrollWidth - scroller.clientWidth <= 1) return;
  const box = scroller.getBoundingClientRect();
  const rect = item.getBoundingClientRect();
  const style = typeof getComputedStyle === "function" ? getComputedStyle(scroller) : null;
  const padLeft = Number.parseFloat(style?.scrollPaddingLeft ?? "") || 0;
  const padRight = Number.parseFloat(style?.scrollPaddingRight ?? "") || 0;
  const viewLeft = box.left + scroller.clientLeft + padLeft;
  const viewRight = box.left + scroller.clientLeft + scroller.clientWidth - padRight;
  let delta = 0;
  if (rect.left < viewLeft || rect.width > viewRight - viewLeft) delta = rect.left - viewLeft;
  else if (rect.right > viewRight) delta = rect.right - viewRight;
  if (Math.abs(delta) < 1) return;
  const left = scroller.scrollLeft + delta;
  if (smooth && typeof scroller.scrollTo === "function" && !prefersReducedMotion()) {
    scroller.scrollTo({ left, behavior: "smooth" });
  } else {
    scroller.scrollLeft = left;
    updateScrollFade(scroller);
  }
}
function useScrollFade(ref) {
  useIsoLayoutEffect(() => {
    const scroller = ref.current;
    if (!scroller) return void 0;
    const update = () => updateScrollFade(scroller);
    update();
    scroller.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(update);
      observer.observe(scroller);
      for (const child of Array.from(scroller.children)) observer.observe(child);
    }
    return () => {
      scroller.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer?.disconnect();
    };
  }, [ref]);
  useIsoLayoutEffect(() => {
    if (ref.current) updateScrollFade(ref.current);
  });
}
export {
  prefersReducedMotion,
  revealInScroller,
  updateScrollFade,
  useIsoLayoutEffect,
  useScrollFade
};
//# sourceMappingURL=scroller.js.map
